module.exports = __webpack_public_path__ + "static/extended-reality-banner-img-962225612002f87d05745a170c82faf6.png";